import e from "./internal/_arrayReduce.mjs";
import o from "./internal/_curry2.mjs";
import p from "./internal/_dispatchable.mjs";
import i from "./internal/_map.mjs";
import n from "./internal/_xmap.mjs";
import c from "./curryN.mjs";
import l from "./keys.mjs";
var j = /* @__PURE__ */ o(
  /* @__PURE__ */ p(["fantasy-land/map", "map"], n, function(t, r) {
    switch (Object.prototype.toString.call(r)) {
      case "[object Function]":
        return c(r.length, function() {
          return t.call(this, r.apply(this, arguments));
        });
      case "[object Object]":
        return e(function(a, m) {
          return a[m] = t(r[m]), a;
        }, {}, l(r));
      default:
        return i(t, r);
    }
  })
);
export {
  j as default
};
